import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=0c1179d4&scoped=true"
import script from "./FileView.vue?vue&type=script&lang=js"
export * from "./FileView.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./FileView.vue?vue&type=style&index=0&id=0c1179d4&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0c1179d4",
  null
  ,true
)

export default component.exports